import { createTheme } from '@mui/material/styles'
import '@mui/x-data-grid/themeAugmentation'
import './themes.css'

export const lightTheme = createTheme({
  palette: {
    type: 'light',
    primary: {
      main: '#002678',
      dark: 'rgba(0, 38, 120, 0.6)',
      light: 'rgba(0, 38, 120, 0.2)'
    },
    text: {
      primary: '#212121',
      secondary: '#666666'
    },
    secondary: {
      main: '#4FE1B7',
      dark: '#43BD99',
      light: '#03A9F4',
      deep: '#0F7B5C',
      hover: 'rgba(79, 225, 183, 0.04)'
    },
    error: {
      main: '#D32F2F',
      dark: '#C62828'
    },
    success: {
      main: '#1AAA71',
      dark: '#1B5E20',
      light: '#4CAF50'
    },
    warning: {
      main: '#EF6C00'
    },
    disabledBackground: 'rgba(0, 0, 0, 0.12)'
  },
  typography: {
    fontFamily: 'Nunito Sans, Poppins, Arial, sans-serif',
    title1: {
      fontSize: '34px',
      fontWeight: 600,
      color: '#002678'
    },
    subtitle1: {
      fontSize: '24px',
      fontWeight: 700,
      color: '#577699'
    },
    subtitle2: {
      fontSize: '18px',
      fontWeight: 600,
      color: '#577699'
    },
    subtitle3: {
      fontSize: '20px',
      fontWeight: 600,
      color: '#002678'
    },
    subtitle4: {
      fontSize: '16px',
      fontWeight: 700,
      color: '#002678'
    },
    subtitle5: {
      fontSize: '16px',
      fontWeight: 700,
      color: '#212121'
    },
    subtitle6: {
      fontSize: '20px',
      fontWeight: 600,
      color: '#212121'
    },
    body3: {
      fontSize: '16px',
      color: '#212121'
    },
    body4: {
      fontSize: '14px',
      color: '#212121'
    },
    body5: {
      fontSize: '14px',
      color: '#666666'
    },
    body6: {
      fontSize: '14px',
      color: '#212121',
      fontWeight: 700
    },
    body7: {
      fontSize: '14px',
      color: '#666666',
      fontWeight: 700
    },
    body8: {
      fontSize: '14px',
      color: '#002678',
      fontWeight: 400
    },
    button: {
      textTransform: 'none'
    }
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '*::-webkit-scrollbar': {
          width: '16px'
        },
        '*::-webkit-scrollbar-track': {
          background: '#eee'
        },
        '*::-webkit-scrollbar-thumb': {
          background: '#bdbdbd',
          borderRadius: '10px',
          border: '4px solid transparent',
          backgroundClip: 'content-box',
          '&:hover': {
            background: '#9e9e9e',
            borderRadius: '10px',
            border: '4px solid transparent',
            backgroundClip: 'content-box'
          }
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          border: 'none',
          boxShadow: '0 1px 20px 0 rgba(0, 0, 0, 0.12)'
        }
      }
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true
      },
      styleOverrides: {
        root: {
          borderRadius: '8px',
          fontFamily: '"Nunito Sans", "Poppins", "Arial", sans-serif'
        }
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          '&.Mui-checked': {
            color: '#43BD99'
          },
          '&.MuiCheckbox-indeterminate': {
            color: '#43BD99'
          }
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: 'rgba(4, 225, 183, 0.08)', // 设置选中项的背景色
            '&:hover': {
              backgroundColor: 'rgba(4, 225, 183, 0.08)' // 设置选中项 hover 时的背景色
            }
          }
        }
      }
    },
    MuiDataGrid: {
      styleOverrides: {
        row: {
          '&:hover': {
            backgroundColor: 'rgba(79, 225, 183, 0.08)'
          },
          '&.Mui-selected': {
            backgroundColor: 'rgba(79, 225, 183, 0.08)',
            '&:hover': {
              backgroundColor: 'rgba(79, 225, 183, 0.12)' // 选中行的hover颜色可以稍深一些
            }
          }
        }
      }
    },
    MuiSwitch: {
      styleOverrides: {
        switchBase: {
          '&.Mui-checked': {
            color: '#43BD99',
            '& + .MuiSwitch-track': {
              backgroundColor: '#43BD99',
              opacity: 0.5
            }
          },
          '&.Mui-disabled': {
            '&.Mui-checked': {
              color: '#ffffff'
            },
            '& + .MuiSwitch-track': {
              backgroundColor: '#000000',
              opacity: 0.12
            }
          }
        }
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          color: '#D32F2F'
        }
      }
    }
  },
  mixins: {}
})

export const darkTheme = createTheme({
  palette: {
    type: 'dark',
    primary: {
      main: '#002678',
      dark: 'rgba(0, 38, 120, 0.6)',
      light: 'rgba(0, 38, 120, 0.2)'
    },
    secondary: {
      main: '#01579B',
      dark: '#01579B',
      light: '#03A9F4'
    },
    text: {
      primary: '#212121',
      secondary: '#666666'
    }
  },
  typography: {
    fontFamily: 'Nunito Sans, Poppins, Arial, sans-serif',
    subtitle1: {
      fontSize: '24px',
      fontWeight: 700
    },
    subtitle2: {
      fontSize: '18px',
      fontWeight: 600
    }
  },
  overrides: {
    MuiInputBase: {
      input: {
        '&:-webkit-autofill': {
          transitionDelay: '9999s',
          transitionProperty: 'background-color, color'
        }
      }
    }
  }
})
